import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './slices/authSlice';
import filesReducer from './slices/filesSlice';
import folderReducer from './slices/folderSlice';
import shareReducer from './slices/shareSlice';
import uiReducer from './slices/uiSlice';
import trashReducer from './slices/trashSlice';
import favoriteReducer from './slices/favoriteSlice';
import storageReducer from './slices/storageSlice';
import cloudIntegrationReducer from './slices/cloudIntegrationSlice';
import permissionsReducer from './slices/permissionsSlice';
import cloudReducer from './slices/cloudSlice';
import uploadReducer from './slices/uploadSlice';
import profileReducer from './slices/profileSlice';
import clipboardReducer from '../utils/clipboardManager';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    files: filesReducer,
    folders: folderReducer,
    share: shareReducer,
    ui: uiReducer,
    trash: trashReducer,
    favorites: favoriteReducer,
    storage: storageReducer,
    cloudIntegration: cloudIntegrationReducer,
    permissions: permissionsReducer,
    cloud: cloudReducer,
    upload: uploadReducer,
    profile: profileReducer,
    clipboard: clipboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector; 